import { arrayOf, number, shape, string } from 'prop-types'
import { useHistory } from 'react-router-dom'

import { PanelStore } from 'stores'
import { getTerritoryLinkByType } from 'utils/territoryUtils'

import './index.scss'

const TopicListSmall = ({ topics, territories, tooltippedText = '', noLink, ...props }) => {
  const history = useHistory()

  const territoriesList = territories?.length ? territories : topics

  function handleClick(e) {
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    if (noLink) {
      return
    }

    const firstTopic = territoriesList[0]

    if (firstTopic.title) {
      history.push(`/topic/${topics[0].topicId}`)
      return
    }

    if (!firstTopic) {
      return null
    }

    const territoryId = firstTopic.territoryId
    const type = territoryId.split('.')[0]
    const id = territoryId.split('.')[1]
    const currentWorkspace = PanelStore?.selectedPanel?.panelId

    const url = getTerritoryLinkByType(type, id, currentWorkspace)

    history.push(url)
  }

  const ariaLabel = territoriesList
    .slice(1)
    .map(topic => topic.name || topic.title)
    .join(`\n`)

  if (territoriesList.length === 0) {
    return null
  }

  return (
    <div className={`TopicListSmall ${props?.className}`}>
      <div className="TopicListSmall-topics">
        <span
          onClick={handleClick}
          className={`${tooltippedText ? 'tooltipped tooltipped-s' : ''}`}
          aria-label={tooltippedText}
        >
          <h6>{territoriesList[0]?.name || territoriesList[0]?.title}</h6>
        </span>

        {territoriesList.length > 1 && (
          <>
            {' '}
            <span className="tooltipped tooltipped-s tooltipped-multiline" aria-label={ariaLabel}>
              <h6>+{territoriesList.length - 1}</h6>
            </span>
          </>
        )}
      </div>
    </div>
  )
}

TopicListSmall.propTypes = {
  topics: arrayOf(
    shape({
      title: string.isRequired,
      topicId: number.isRequired,
    })
  ),
  territories: arrayOf(
    shape({
      name: string.isRequired,
      territoryId: string.isRequired,
    })
  ),
}

TopicListSmall.defaultProps = {
  topics: [],
  territories: [],
}

export default TopicListSmall
